<template>
  <div class="add-dynamic">
    <div class="form-content">
      <el-form ref="formRef" :model="currentData" :rules="rules" label-width="100px">
        <!-- 语言 + 分类 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="语言" prop="language_code">
              <el-select v-model="currentData.language_code" placeholder="请选择语言" style="width: 100%;">
                <el-option v-for="item in languageList" :key="item.code" :label="item.name" :value="item.code" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="动态分类" prop="category_id">
              <el-select v-model="currentData.category_id" placeholder="请选择分类" style="width: 100%;">
                <el-option v-for="c in categoryList" :key="c.id" :label="c.name" :value="c.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 标题 -->
        <el-form-item label="标题" prop="title">
          <el-input v-model="currentData.title" placeholder="请输入新闻标题" />
        </el-form-item>
        <!-- 副标题 -->
        <el-form-item label="副标题">
          <el-input v-model="currentData.sub_title" placeholder="请输入副标题（选填）" />
        </el-form-item>
        <!-- 封面图 -->
        <el-form-item label="封面图">
          <upload
            :path="'news'"
            :file-list="coverList"
            :limit="1"
            @success="handleCoverSuccess"
          />
        </el-form-item>
        <!-- SEO关键词 -->
        <el-form-item label="SEO关键词" prop="keyword">
          <el-input v-model="currentData.keyword" placeholder="请输入SEO关键词，多个关键词用逗号分隔" />
        </el-form-item>
        <!-- 首页推荐 -->
        <el-form-item label="首页推荐">
          <el-switch
            v-model="currentData.is_home"
            :active-value="1"
            :inactive-value="0"
            active-text="推荐"
            inactive-text="不推荐"
          ></el-switch>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item label="内容" prop="content">
          <div class="rich-text-editor-container">
            <rich-text-editor
              v-model="currentData.content"
              :path="'news'"
              placeholder="请输入新闻内容"
              @change="handleContentChange"
            ></rich-text-editor>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表单操作 -->
    <div class="form-actions">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">保存</el-button>
    </div>
  </div>
</template>

<script>
import { getLanguage } from '@/api/public'
import { addNews, updateNews, getNewsCategories } from '@/api/website'
import RichTextEditor from '@/components/tool/RichTextEditor'
import Upload from '@/components/tool/lib/upload/index.vue'

export default {
  name: 'AddDynamic',
  components: {
    RichTextEditor,
    Upload
  },
  props: {
    dynamic: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      submitting: false,
      languageList: [],
      categoryList: [],
      coverList: [],
      currentData: {
        title: '',
        sub_title: '',
        cover: '',
        content: '',
        keyword: '',
        category_id: '',
        language_code: 'zh',
        is_home: 0
      },
      rules: {
        language_code: [{ required: true, message: '请选择语言', trigger: 'change' }],
        category_id: [{ required: true, message: '请选择分类', trigger: 'change' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        keyword: [{ required: true, message: '请输入SEO关键词', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.getLanguageList()
    this.getCategoryList()
  },
  watch: {
    dynamic: {
      handler(newDynamic) {
        if (newDynamic) {
          this.currentData = {
            id: newDynamic.id,
            title: newDynamic.title || '',
            sub_title: newDynamic.sub_title || '',
            cover: newDynamic.cover || '',
            content: newDynamic.content || '',
            keyword: newDynamic.keyword || '',
            category_id: newDynamic.category_id || '',
            language_code: newDynamic.language_code || 'zh',
            is_home: newDynamic.is_home != null ? Number(newDynamic.is_home) : 0
          }
          // 封面图回显
          if (newDynamic.cover) {
            this.coverList = [{ name: '封面', url: newDynamic.cover }]
          } else {
            this.coverList = []
          }
        } else {
          this.resetForm()
        }
      },
      immediate: true
    }
  },
  methods: {
    resetForm() {
      this.currentData = {
        title: '',
        sub_title: '',
        cover: '',
        content: '',
        keyword: '',
        category_id: '',
        language_code: 'zh',
        is_home: 0
      }
      this.coverList = []
    },
    handleCancel() {
      this.$emit('cancel')
    },
    handleContentChange(content) {
      this.currentData.content = content
    },
    handleCoverSuccess(url) {
      this.currentData.cover = url[0]
    },
    async getLanguageList() {
      try {
        var response = await getLanguage()
        this.languageList = response.data || []
      } catch (error) {
        console.error('获取语言列表失败:', error)
      }
    },
    getCategoryList() {
      getNewsCategories().then(function(res) {
        if (res.code === 200) {
          var categories = []
          res.data.forEach(function(item) {
            var language = ''
            if (item.translations) {
              Object.keys(item.translations).forEach(function(key) {
                if (language === '' && item.translations[key].name) {
                  language = item.translations[key].name
                }
              })
            }
            categories.push({ id: item.id, name: language || '未命名' })
          })
          this.categoryList = categories
        }
      }.bind(this))
    },
    handleSubmit() {
      var self = this
      this.$refs.formRef.validate(function(valid) {
        if (!valid) return
        self.submitting = true
        var data = JSON.parse(JSON.stringify(self.currentData))
        var promise
        if (data.id) {
          promise = updateNews(data.id, data)
        } else {
          promise = addNews(data)
        }
        promise.then(function(res) {
          self.submitting = false
          if (res.code === 200) {
            self.$emit('save', true)
          } else {
            self.$message.error(res.message || '操作失败')
          }
        }).catch(function() {
          self.submitting = false
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.add-dynamic {
  box-sizing: border-box;
  padding: 0 20px;
}

.form-content {
  box-sizing: border-box;
  margin-bottom: 30px;
}

.rich-text-editor-container {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background-color: #f9f9f9;
  padding: 10px;
  min-height: 300px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f2f5;
}

@media (max-width: 768px) {
  .add-dynamic {
    padding: 10px 0;
  }

  .form-content {
    margin-bottom: 20px;
  }

  .rich-text-editor-container {
    min-height: 200px;
  }

  .form-actions {
    flex-direction: column;
  }

  .form-actions .el-button {
    width: 100%;
  }
}
</style>
